import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`

export const UpperSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;

    h1 {
        color: #002666;
        font-size: 32px;
    }

    a {
        color: #a3a3a3;
        text-decoration: underline;
    }
`